export const UniversalSearchCategory = {
  LOCAL_ACCOMMODATION: 'LOCAL_ACCOMMODATION',
  GLOBAL_ACCOMMODATION: 'GLOBAL_ACCOMMODATION',
  LOCAL_LEISURE: 'LOCAL_LEISURE',
  ENTERTAINMENT: 'ENTERTAINMENT',
  FLIGHT: 'FLIGHT',
  NOL_TICKET: 'NOL_TICKET',
  GLOBAL_TNA: 'GLOBAL_TNA', // 해외투어티켓
} as const;

// 검색홈과 매핑되는 레거시 탭 key
export const SearchHomeTabName = {
  [UniversalSearchCategory.LOCAL_ACCOMMODATION]: 'place',
  [UniversalSearchCategory.GLOBAL_ACCOMMODATION]: 'gplace',
  [UniversalSearchCategory.LOCAL_LEISURE]: 'leisure',
  [UniversalSearchCategory.ENTERTAINMENT]: 'entertainment',
};

// 검색결과 페이지의 쿼리 파라미터로 사용되는 카테고리 값 (국내숙소, 해외숙소, 국내레저)
export const UniversalSearchCategoryQueryValue = {
  [UniversalSearchCategory.LOCAL_ACCOMMODATION]: 'local',
  [UniversalSearchCategory.GLOBAL_ACCOMMODATION]: 'global',
  [UniversalSearchCategory.LOCAL_LEISURE]: 'leisure',
  [UniversalSearchCategory.ENTERTAINMENT]: 'entertainment',
} as const;

// 검색결과 페이지의 쿼리 파라미터 값과 카테고리 key 매핑
export const UniversalSearchCategoryQueryValueToCategoryKey = {
  [UniversalSearchCategoryQueryValue.LOCAL_ACCOMMODATION]: UniversalSearchCategory.LOCAL_ACCOMMODATION,
  [UniversalSearchCategoryQueryValue.GLOBAL_ACCOMMODATION]: UniversalSearchCategory.GLOBAL_ACCOMMODATION,
  [UniversalSearchCategoryQueryValue.LOCAL_LEISURE]: UniversalSearchCategory.LOCAL_LEISURE,
  [UniversalSearchCategoryQueryValue.ENTERTAINMENT]: UniversalSearchCategory.ENTERTAINMENT,
};

// 통합검색 페이지 진입시 유효한 카테고리 (국내숙소, 해외숙소, 국내레저, 공연/전시)
export const ValidCategories = [
  UniversalSearchCategoryQueryValue.LOCAL_ACCOMMODATION,
  UniversalSearchCategoryQueryValue.GLOBAL_ACCOMMODATION,
  UniversalSearchCategoryQueryValue.LOCAL_LEISURE,
  UniversalSearchCategoryQueryValue.ENTERTAINMENT,
] as const;

export const CookieKey = {
  CHECK_IN_OUT_DOMESTIC: 'cinout-domestic',
  CAPACITY_DOMESTIC: 'capacity-domestic',
  CHECK_IN_OUT_GLOBAL: 'cinout-global',
  CAPACITY_GLOBAL: 'capacity-global',
  LOCATION: 'location',
};

export const DEFAULT_COOKIE_OPTIONS = {
  maxAge: 60 * 60 * 24 * 30, // 30일
  domain: '.yanolja.com',
};

export const FILTER_LABEL = '필터';
export const SORT_LABEL = '정렬';

export const MAX_STAY_DAYS_GLOBAL = 28; // 해외 숙소는 최대 28일
export const MAX_STAY_DAYS_LOCAL = 9; // 국내 숙소는 최대 9일
